import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { useAuth } from '@/context/AuthContext'

import { useCebiaLogin } from 'BrokerTsLib/src/hooks'
import { useReturnUrlNavigate } from 'BrokerTsLib/src/hooks/useReturnUrlNavigate'
import { Container } from '../../components/Container'
import { Section } from '../../components/Section'
import { SSOLoginForm } from '../../containers/SSOLoginForm'

export const SSOLoginPage = () => {
  const [searchParams] = useSearchParams()
  const returnUrl = searchParams.get('returnUrl') ?? undefined
  const error = searchParams.has('error')

  const returnUrlNavigate = useReturnUrlNavigate()
  const { user, isLogged, isLoading } = useAuth()
  useEffect(() => {
    if (user?.logged && !isLoading) {
      returnUrlNavigate(returnUrl ?? '/')
    }
  }, [user, isLoading, isLogged, returnUrl, returnUrlNavigate])
  
  useCebiaLogin(searchParams.has('cebia'), returnUrl)

  return (
    <Section variant="login">
      <Container>
        <SSOLoginForm returnUrl={returnUrl} error={error} />
      </Container>
    </Section>
  )
}
